/**
 * Created by Administrator on 2017/7/2.
 */

import {SHOWCAROUSEL} from './actionTypes.js';

export default (state, action) => {
    switch (action.type) {
        case SHOWCAROUSEL: {
            return {
                BlogList: [{blogId: 1, title: 'first blog', titleImgUrl: './images/1.PNG',introduce:'这是一篇新的博客，并没有什么内容'},
                    {blogId: 2, title: 'second blog', titleImgUrl: './images/2.PNG',introduce:'这是一篇新的博客，并没有什么内容'},
                    {blogId: 3, title: 'third blog', titleImgUrl: './images/3.PNG',introduce:'这是一篇新的博客，并没有什么内容'}]
            };
        }
        default: {
            return {
                BlogList: [{blogId: 1, title: 'first blog', titleImgUrl: './images/20ev2.jpg',introduce:'这是一篇新的博客，并没有什么内容'},
                    {blogId: 2, title: 'second blog', titleImgUrl: './images/123.PNG',introduce:'这是一篇新的博客，并没有什么内容'},
                    {blogId: 3, title: 'third blog', titleImgUrl: './images/321.jpg',introduce:'这是一篇新的博客，并没有什么内容'}]
            };
        }
    }
}


// WEBPACK FOOTER //
// ./src/Component/BlogList/reducer.js